import { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { useStores } from '../../../utils'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { CloseButton } from '../../atoms/CloseButton'
import { OutSideOverlay } from '../../atoms/OutSideOverlay'
import { JobApplicationModalLeftContent } from '../JobApplicationModalLeftContent'
import { JobApplicationModalRightContent } from '../JobApplicationModalRightContent'

type Props = {
  job: IJobBase
}

export const JobApplicationModal: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation(['companies-users-[id]', 'validation'])
  const { ui } = useStores()

  const toggleModal = () => {
    ui.toggleJobApplicationModal()
  }

  return (
    <div className={styles.container} style={ui.isJobApplicationModalOpen ? {} : { display: 'none' }}>
      <OutSideOverlay onClick={toggleModal} isOpen={ui.isJobApplicationModalOpen} backGroundColor='gray' />
      <div className={styles.modal}>
        <div className={styles.card}>
          <div className={styles.heading}>
            <h2>{t('応募する')}</h2>
            <div className={styles.closeButton}>
              <CloseButton onClick={toggleModal} isLarge />
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.contentLeft}>
              <JobApplicationModalLeftContent />
            </div>
            <div className={styles.contentRight}>
              <JobApplicationModalRightContent job={job} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
